import React, {
  useMemo,
  useCallback,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import { getStripeCheckoutUrl } from "../../../config/stripeConfig";
import styles from "./Subscribe.module.css";
import type { SubscribeCatalogProduct } from "../types";
import { sortSubscribeProductsByPriceAsc } from "../utils/productCatalog";
import { VisitWebToSubscribeModal } from "./VisitWebToSubscribeModal";

export function SubscriptionList({
  uid,
  catalogProducts,
  catalogLoading = false,
  catalogError = false,
  activePriceId,
  currentPeriodEnd,
  cancelAt,
  setStep,
  step,
  handleSubmit
}: {
  uid: string | null;
  catalogProducts: SubscribeCatalogProduct[];
  catalogLoading?: boolean;
  catalogError?: boolean;
  activePriceId?: string;
  currentPeriodEnd?: string;
  cancelAt?: string;
  setStep?: Dispatch<SetStateAction<number>>;
  step?: number;
  handleSubmit?: () => void;
}) {
  const returnBase =
    typeof window !== "undefined"
      ? `${window.location.origin}${window.location.pathname}`
      : "";

  const isInApp =
    typeof window !== "undefined" &&
    Boolean((window as any).ReactNativeWebView);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const productsSorted = useMemo(() => {
    const list = Array.isArray(catalogProducts) ? catalogProducts : [];
    return sortSubscribeProductsByPriceAsc(list).filter((p) => p.default_price);
  }, [catalogProducts]);

  const handleDrawerChange = useCallback((nextOpen: boolean) => {
    setDrawerOpen(nextOpen);
  }, []);

  if (catalogLoading) {
    return (
      <div className={styles.pagePadding}>
        <p className={styles.mutedLine}>Loading plans…</p>
      </div>
    );
  }

  if (catalogError) {
    return (
      <div className={styles.pagePadding}>
        <p className={styles.mutedLine}>
          Couldn’t load plans. Check your connection and try again.
        </p>
      </div>
    );
  }

  if (productsSorted.length === 0) {
    return (
      <div className={styles.pagePadding}>
        <p className={styles.mutedLine}>No plans available right now.</p>
      </div>
    );
  }

  return (
    <div className={styles.pagePadding}>
      <div className={styles.listWrap}>
        {productsSorted.map((product) => {
          const isCurrent =
            Boolean(activePriceId) && product.default_price === activePriceId;
          return (
            <div key={product.id} className={styles.cardShell}>
              <div className={styles.cardTitleRow}>
                <span className="grid-title">{product.name}</span>
                {isCurrent ? (
                  <span className={styles.currentBadge}>Current plan</span>
                ) : null}
              </div>
              <p className={styles.priceLine}>
                {product.price ?? "—"} / month {product.description ?? ""}
              </p>
              {isCurrent ? (
                <p className={styles.mutedLine}>
                  You are already on this plan. Use Manage billing to change or
                  cancel.
                </p>
              ) : isInApp &&
                product.id !== "prod_V5acriC4lmsU3X" &&
                product.id !== "prod_V5ae23jGJe7616" ? (
                <button
                  type="button"
                  className="proceed-button"
                  onClick={() => setDrawerOpen(true)}
                >
                  Get {product.id}
                </button>
              ) : product.id === "prod_V5acriC4lmsU3X" ||
                product.id === "prod_V5ae23jGJe7616" ? (
                <button
                  type="button"
                  className="proceed-button"
                  onClick={() => {
                    console.log("hello world");
                    if (
                      setStep !== undefined &&
                      step !== undefined &&
                      step !== 3
                    ) {
                      setStep(step + 1);
                      return;
                    }
                    if (handleSubmit !== undefined) {
                      handleSubmit();
                    }
                  }}
                >
                  Get Free
                </button>
              ) : (
                <form action={getStripeCheckoutUrl()} method="POST">
                  <input
                    type="hidden"
                    name="price_id"
                    value={product.default_price}
                  />
                  <input
                    type="hidden"
                    name="client_reference_id"
                    value={uid || ""}
                  />
                  <input
                    type="hidden"
                    name="success_url"
                    value={
                      `${returnBase}?success=true&session_id=` +
                      "{CHECKOUT_SESSION_ID}"
                    }
                  />
                  <input
                    type="hidden"
                    name="cancel_url"
                    value={`${returnBase}?canceled=true`}
                  />
                  <button type="submit" className="proceed-button">
                    Get {product.id}
                  </button>
                </form>
              )}
            </div>
          );
        })}
      </div>
      <VisitWebToSubscribeModal
        drawerOpen={drawerOpen}
        handleDrawerChange={handleDrawerChange}
        setDrawerOpen={setDrawerOpen}
      />
    </div>
  );
}
